module.exports = __webpack_public_path__ + "static/media/tareas.aec807c1.svg";